module.exports = __webpack_public_path__ + "img/Image - Header 5(3).97cbd248.png";